import { loadResultsPage } from "@/helpers/Results";
import { resultsPage } from "@/helpers/Results/constants";
import { getCompetitionsToMap, getUniqueCompetitions } from "@/helpers/Results/menu";
import { resolveResultsRoute } from "@/helpers/Results/route";
import { getMetaDescription, getTitle } from "@/helpers/Results/seo";
import { Service } from "models/Service";

/**
 * Página de estadísticas de fútbol (`deportes/estadisticas/...`).
 *
 * Hace de resolver: interpreta la URL una sola vez con `resolveResultsRoute` y deja
 * la ruta ya resuelta junto con la data en `properties.service.data`, para que el
 * template no vuelva a parsear la URL.
 */
export class Results extends Service {
    constructor() {
        super({
            adsPath: "servicios/home",
            section: "deportes",
            template: "Results",
            titleHeader: "Estadísticas",
            widthFull: false,
        });
    }

    parseData = async (match, menu, query) => {
        const parseUrl = match.join("/");
        this.setSlug(parseUrl);

        const route = resolveResultsRoute({ pathSegments: match, query });

        const competitionsMenu = menu?.menuestadisticasligas?.item?.items || [];
        const competitionsToMap = getCompetitionsToMap(competitionsMenu) ?? [];

        const data = await loadResultsPage(route, { competitionsToMap });

        const competitionKeys = {};
        if (route.page !== resultsPage.home) {
            const competitionId =
                data?.competitionData?.id || data?.matchDetail?.matchInfo?.competition?.id || null;

            competitionKeys.competitionId = competitionId;
            competitionKeys.competitionStage =
                competitionsMenu?.[0]?.extras?.find((item) => item.id == competitionId)?.stage || 0;
        }

        const metaTitle = getTitle(route.page, data?.competitionName, data?.teamData, data?.matchDetail);
        const metaDescription = getMetaDescription(
            route.page,
            data?.competitionName,
            data?.teamData,
            data?.matchDetail
        );

        this.setTitle(metaTitle);
        this.setMeta(
            this.parseMeta({
                description: metaDescription,
                keywords: "estadisticas",
                title: metaTitle,
                url: parseUrl,
                extra: [],
            })
        );

        this.setData({
            route,
            competitionsMenu,
            uniqueCompetitions: getUniqueCompetitions(competitionsMenu) || null,
            dataCompetition: data,
            ...competitionKeys,
        });
    };
}
